import { createPersistentStore } from "src/utilities/localStorage/create"
import { CheckoutValue, CheckoutValueWithConfirmationState } from "../helpers/formValue"

export type CheckoutShippingAddressData = {
  email?: CheckoutValue<string>
  signUpForNewsletter?: boolean
  phone?: CheckoutValue<string>
  phoneNormalized?: string | undefined
  firstName?: CheckoutValue<string>
  lastName?: CheckoutValue<string>
  companyName?: CheckoutValue<string>
  street?: CheckoutValueWithConfirmationState<string>
  countryCode?: CheckoutValueWithConfirmationState<string>
  regionCode?: CheckoutValueWithConfirmationState<string>
  postalCode?: CheckoutValueWithConfirmationState<string>
  city?: CheckoutValueWithConfirmationState<string>
  note?: string
}

export type CheckoutBillingAddressData = {
  firstName?: CheckoutValue<string>
  lastName?: CheckoutValue<string>
  companyName?: CheckoutValue<string>
  street?: CheckoutValueWithConfirmationState<string>
  countryCode?: CheckoutValueWithConfirmationState<string>
  regionCode?: CheckoutValueWithConfirmationState<string>
  postalCode?: CheckoutValueWithConfirmationState<string>
  city?: CheckoutValueWithConfirmationState<string>
  note?: string
}

export type CheckoutContactData = {
  unsavedChanges: boolean
  submitting: boolean
  showInputErrors: boolean
  error: string | null
  useShippingAddressForBilling: boolean
  shippingAddress: CheckoutShippingAddressData
  billingAddress: CheckoutBillingAddressData
}

const defaultState: CheckoutContactData = {
  unsavedChanges: false,
  submitting: false,
  showInputErrors: false,
  error: null,
  useShippingAddressForBilling: true,
  shippingAddress: {},
  billingAddress: {},
}

export const checkoutContactStore = createPersistentStore(() => defaultState, {
  name: "checkout-contact",
  version: 4,
  partialize: (state) => {
    return {
      // After a purchase, we still have all the previous user data but it is
      // not yet saved to the cart. Setting this to true ensures the user has
      // to save at least once. The only unwanted effect of this is that
      // reloading on the payment form page brings the user back to the
      // contact form page.
      unsavedChanges: true,

      useShippingAddressForBilling: state.useShippingAddressForBilling,
      shippingAddress: state.shippingAddress,
      billingAddress: state.billingAddress,
    }
  },
})

export function mergeCheckoutShippingAddress(changes: Partial<CheckoutShippingAddressData>) {
  const state = checkoutContactStore.getState()

  checkoutContactStore.setState({
    unsavedChanges: true,
    shippingAddress: {
      ...state.shippingAddress,
      ...changes,
    },
  })
}

export function mergeCheckoutBillingAddress(changes: Partial<CheckoutBillingAddressData>) {
  const state = checkoutContactStore.getState()

  checkoutContactStore.setState({
    unsavedChanges: true,
    billingAddress: {
      ...state.billingAddress,
      ...changes,
    },
  })
}
